<div class="send-instructions-container">
  <h3 class="section-title">
    Your next step:
  </h3>
  <p class="instruction-message">
    After sending your studies, the facility users will be automatically notified.
  </p>
</div>
